import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./nikshay.css";
import { Tabs, Tab } from "react-bootstrap";
import NikshayTestTab from "./NikshayTestTab";
import Treatmentdetails from "./treatmentDetails/Treatmentdetails";
import { canView } from "../../../utils/permissionHelper";
import { nikshayAPI } from "../../../services/nikshay.api";
import NikshayEpisodeCard from "./NikshayEpisodeCard";

// Treatment Details is still under development — flip to true to re-enable the tab.
const SHOW_TREATMENT_TAB = false;

const RegistrationView = ({ onClose, data, setShowNikshayActions, initialTab }) => {
	const [activeTab, setActiveTab] = useState(initialTab || "details");
	const [refId, setRefId] = useState(null);
	const [episodeDetails, setEpisodeDetails] = useState(null);
	const [selectedEpisodeId, setSelectedEpisodeId] = useState("");
	const [loadingEpisode, setLoadingEpisode] = useState(false);

	const patientId = data?.Id || data?.data?.Id || data?.PatientId || localStorage.getItem("nikshay_patient_id");

	// Initialize selectedEpisodeId when patientId is available
	useEffect(() => {
		if (patientId) {
			setSelectedEpisodeId(patientId);
		}
	}, [patientId]);

	// Fetch episode details when selectedEpisodeId changes
	useEffect(() => {
		if (!selectedEpisodeId) return;

		const fetchEpisodeData = async () => {
			setLoadingEpisode(true);
			try {
				const res = await nikshayAPI.getEpisodeDetails(selectedEpisodeId);
				if (res.success && res.data) {
					setEpisodeDetails(res.data);
				}
			} catch (err) {
				console.error("Error fetching episode details:", err);
			} finally {
				setLoadingEpisode(false);
			}
		};
		fetchEpisodeData();
	}, [selectedEpisodeId]);

	// Sync activeTab if initialTab changes (e.g. navigated back from Add Test)
	useEffect(() => {
		if (initialTab) setActiveTab(initialTab);
	}, [initialTab]);

	// Fetch refId as soon as Patient Details opens — not waiting for tab click
	useEffect(() => {
		if (!patientId) return;

		console.log("[RegistrationView] Calling getTest with patientId:", patientId);
		const fetchRefId = async () => {
			try {
				const testRes = await nikshayAPI.getTest(patientId);
				console.log("[RegistrationView] getTest response:", testRes);
				const id = testRes?.Data?.RefId;
				if (id) setRefId(id);
			} catch (err) {
				console.error("Error fetching refId on Patient Details load:", err);
			}
		};
		fetchRefId();
	}, [patientId]);


	if (!data || data.length === 0) {
		return <p>No patient records found.</p>;
	}

	let permissions = [];
	try {
		const storedPermissions = localStorage.getItem('NIKSHAY_Permissions');
		if (storedPermissions) {
			const parsed = JSON.parse(storedPermissions);

			// ✅ Ensure it's always an array
			permissions = Array.isArray(parsed)
				? parsed
				: Array.isArray(parsed?.permissions)
					? parsed.permissions
					: [];
		}
	} catch (error) {
		console.error('Error parsing permissions:', error);
		permissions = [];
	}

	const canViewPatient = canView(permissions, 'registration');
	const canViewTest = canView(permissions, 'add_test');


	const externalIds = data.ExternalIds;

	const healthId = externalIds.find(
		item => item.Type === "HEALTH_ID"
	)?.Value;

	const healthAddress = externalIds.find(
		item => item.Type === "HEALTH_ADDRESS"
	)?.Value;

	const primaryVerified = data.MobileList?.find(
		item => item.primary === true
	)?.verified;

	return (
		<div className="mt-3 card">
			<div className="card-body">
				<div className="d-flex align-items-center mb-3">
					<img
						src="/images/nikshayicon.svg"
						alt="Nikshay"
						style={{ width: "50px" }}
						className="me-2"
					/>
					<h4 className="mb-0 fw-bold">Patient Details</h4>
				</div>

				<NikshayEpisodeCard
					episodeDetails={episodeDetails}
					selectedEpisodeId={selectedEpisodeId}
					onEpisodeChange={setSelectedEpisodeId}
					loading={loadingEpisode}
				/>

				<Tabs
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					id="patient-details-tabs"
					className="mb-3"
				>

					{canViewPatient && (

						<Tab eventKey="details" title="Enrollment">

							<div className="d-flex justify-content-between align-items-center mb-3">
								<div className="d-flex align-items-center gap-2 ms-auto">
									{/* 
									<button className="btn btn-primary btn-sm" disabled>
										Verify Phone Number
									</button>

									<button className="btn btn-primary btn-sm" disabled>
										Verify ABHA
									</button> */}

									<div
										className="closeDive nikshayclose"
										onClick={() => onClose("handleCloseNikshayview")}
									>
										<img src="/images/closing.svg" alt="Close" />
									</div>
								</div>
							</div>

							<div className="table-responsive">
								<table className="table table-bordered">
									<thead>
										<tr>
											<th>Category</th>
											<th>Info</th>
										</tr>
									</thead>
									<tbody>
										<tr><th>Type of Case Finding</th><td>{data.TypeOfCaseFinding || "-"}</td></tr>
										<tr><th>Date of Enrollment</th><td>{data.RegistrationDate || "-"}</td></tr>
										<tr><th>Phone Number Verified</th><td>{primaryVerified ? "Yes" : "No"}</td></tr>
										<tr><th>Aadhaar Verified</th><td>{data.AadhaarVerified ? "Yes" : "No"}</td></tr>
										<tr><th>ABHA</th><td>{healthId || "-"}</td></tr>
										<tr><th>ABHA Address</th><td>{healthAddress || "-"}</td></tr>
										<tr><th>First Name</th><td>{data.FirstName || "-"}</td></tr>
										<tr><th>Surname</th><td>{data.LastName || "-"}</td></tr>
										<tr><th>Father/Husband's Name</th><td>{data.FathersName || "-"}</td></tr>
										<tr><th>Age</th><td>{data.Age || "-"}</td></tr>
										<tr><th>Date Of Birth</th><td>{data.DateOfBirth || "-"}</td></tr>
										<tr><th>Gender</th><td>{data.Gender || "-"}</td></tr>
										<tr><th>Primary Phone</th><td>{data.PrimaryPhone || "-"}</td></tr>
										<tr><th>Secondary Phone 1</th><td>{data.SecondaryPhone1 || "-"}</td></tr>
										<tr><th>Secondary Phone 2</th><td>{data.SecondaryPhone2 || "-"}</td></tr>
										<tr><th>Secondary Phone 3</th><td>{data.SecondaryPhone3 || "-"}</td></tr>
										<tr><th>Address</th><td>{data.Address || "-"}</td></tr>
										<tr><th>Taluka/Block</th><td>{data.Taluka || "-"}</td></tr>
										<tr><th>Landmark</th><td>{data.Landmark || "-"}</td></tr>
										<tr><th>Pincode</th><td>{data.Pincode || "-"}</td></tr>
										<tr><th>Area</th><td>{data.Area || "-"}</td></tr>
										<tr><th>Marital Status</th><td>{data.MaritalStatus || "-"}</td></tr>
										<tr><th>Occupation</th><td>{data.Occupation || "-"}</td></tr>
										<tr><th>Socioeconomic Status</th><td>{data.SocioeconomicStatus || "-"}</td></tr>
										<tr><th>Symptoms</th><td>{data.Symptom || "-"}</td></tr>
										<tr><th>Key Population/Risk factors</th><td>{data.KeyPopulation || "-"}</td></tr>
										<tr><th>Emergency Contact Person Name</th><td>{data.ContactPersonName || "-"}</td></tr>
										<tr><th>Emergency Contact Person Phone</th><td>{data.ContactPersonPhone || "-"}</td></tr>
										<tr><th>Emergency Contact Person Address</th><td>{data.ContactPersonAddress || "-"}</td></tr>
									</tbody>
								</table>
							</div>
						</Tab>
					)}

					{/* TEST TAB (separate component) */}
					{canViewTest && (
						<Tab eventKey="test" title="Test">
							<div
								className="closeDive nikshayclose"
								onClick={() => onClose("handleCloseNikshayview")}
							>
								<img src="/images/closing.svg" alt="Close" />
							</div>
							<NikshayTestTab
								onClose={onClose}
								setShowNikshayActions={setShowNikshayActions}
								patientId={patientId}
								activeTab={activeTab}
								refId={refId}
							/>
						</Tab>
					)}

				{/* TREATMENT DETAILS TAB — hidden while under development */}
				{SHOW_TREATMENT_TAB && (
					<Tab eventKey="treatment" title="Treatment Details">
						<div
							className="closeDive nikshayclose"
							onClick={() => onClose("handleCloseNikshayview")}
						>
							<img src="/images/closing.svg" alt="Close" />
						</div>
						{activeTab === "treatment" && (
							<Treatmentdetails 
								patientId={patientId} 
								episodeId={selectedEpisodeId || episodeDetails?.overview?.find(o => o.CurrentEpisode)?.CurrentEpisode}
							/>
						)}
					</Tab>
				)}

				</Tabs>

			</div>
		</div>
	);
};

export default RegistrationView;
